import { ListBaseModel } from '@/api/models';
import { reviewTypeEnum } from '@/utils/enum';
import { z } from 'zod';
import { PaymentModel } from './payment';
import {
  BudgetAmountModel,
  businessForm,
  candidateReasonOfInspectionByExternalExpert,
  operationForm,
} from './project';

export const ProjectListElementModel = z.object({
  name: z.string().min(1),
  id: z.string().uuid(),
  overview: z.string().nullish(),
  isPublished: z.boolean(),
  finalizedAmountForInitialBudget: z.number().nullable(),
  negativeFinalizedAmountForInitialBudgetCount: z.number().nullish(),
  lastImplementedFiscalYear: z.number().nullish(),
  budgetData: BudgetAmountModel.array(),
  previousYearExecutionAmount: z.number().nullable(),
  negativePreviousYearExecutionAmountCount: z.number().nullable(),
  previousYearExecutionRate: z.number().nullable(),
  requestedAmount: z.number().nullable(),
  negativeRequestedAmountCount: z.number().nullish(),
  finalizedAmountForSupplementaryBudget: z.number().nullable(),
  negativeFinalizedAmountForSupplementaryBudgetCount: z.number().nullish(),
  finalizedAmountForCarriedForward: z.number().nullable(),
  negativeFinalizedAmountForCarriedForwardCount: z.number().nullish(),
  finalizedAmountForReserve: z.number().nullable(),
  negativeFinalizedAmountForReserveCount: z.number().nullish(),
  finalizedAmount: z.number().nullable(),
  negativeFinalizedAmountCount: z.number().nullish(),
  ministryName: z.string(),
  projectNumber: z.string().nullable(),
  candidateReasonsOfInspectionByExternalExpert:
    candidateReasonOfInspectionByExternalExpert.array().nullish(),
  inspectionByExternalExpertReviewType: reviewTypeEnum.nullish(),
  paymentData: z.object({
    name: PaymentModel.shape.name.nullable(),
    corporateNumber: PaymentModel.shape.corporateNumber.nullable(),
    amount: z.number().nullable(),
    negativeAmountCount: z.number().nullish(),
  }),
  ownershipRatio: z.number().nullable(),
  previousYearTotalIncome: z.number().nullable(),
  previousYearTotalExpense: z.number().nullable(),
  negativePreviousYearTotalExpenseCount: z.number().nullish(),
  negativePreviousYearTotalIncomeCount: z.number().nullish(),
  previousYearAdministrativeExpenseRate: z.number().nullable(),
  previousYearDivergenceRate: z.number().nullable(),
  isLocked: z.boolean(),
  fundOwner: z.string().nullish(),
  compositionBackgroundsFiscalYearOfCreation: z.number().nullish(),
  scheduledEndEndDateOfNewApplicationReceiving: z.string().nullish(),
  scheduledEndEndDate: z.string().nullish(),
  fundSheetNumber: z.number().nullish(),
  fundSheetBranchNumber: z.number().nullish(),
  businessForms: businessForm.array().nullish(),
  operationForms: operationForm.array().nullish(),
  startYear: z.number().int().nullable(),
  endYear: z.number().int().nullable(),
  purpose: z.string().nullish(),
  task: z.string().nullish(),
  beginningOfTheFundBalance: z.number().nullish(),
  previousYearAmountReturnedToTheNationalTreasury: z.number().nullish(),
  previousYearAdministrativeExpense: z.number().nullish(),
  organization: z.object({
    flatten: z.object({
      names: z.string().array(),
    }),
  }),
  /** 編集可能かどうか */
  isEditable: z.boolean(),
  publishedAt: z.string().nullable(),
  lockedAt: z.string().nullable(),
});

export const ProjectsListModel = ListBaseModel.extend({
  results: ProjectListElementModel.array(),
});
